import { ReactKit } from '@team/react';
import { Counter } from './counter';
import { Dot } from './dot';

export const Badge = ReactKit.createCompoundComponent(Counter, { Dot });

Badge.displayName = 'Badge';
Badge.Dot.displayName = 'BadgeDot';
